export default function () {
    const scrollerIndicationElements = document.querySelectorAll('[data-scroller-indication]');

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                removeScroller(entry.target);
            }
        })
    });

    scrollerIndicationElements.forEach(element => {
        observer.observe(element);
    });
}

function removeScroller(element) {
    setTimeout(() => {
        element.remove();
    }, 3000);
}
